import React from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
    selectField: {
        paddingTop: 0,
        marginTop: 0,
        marginBottom: 0,
    },
    menuPopover: {
        zIndex: 1500,
    },
}));

// `formatOptionLabel` is optional and affects the label only -- the option value
// stays the raw datum so filtering keeps matching what the api returned.
const generateOptionsFromData = (data, formatOptionLabel) => {
    const values = data
        .reduce((a, b) => {
            if (a.indexOf(b) < 0) a.push(b);
            return a;
        }, [])
        .map(item => ({
            label: formatOptionLabel ? formatOptionLabel(item) : item,
            value: item,
        }));
    return values;
};

const SelectFilter = ({ onChange, filter, value, data }) => {
    const classes = useStyles();
    let { filterOptions } = filter;
    if (!filterOptions) {
        filterOptions = generateOptionsFromData(
            data.map(item => item[filter.field]),
            filter.formatOptionLabel
        );
    }
    if (typeof filterOptions === 'function') {
        filterOptions = generateOptionsFromData(
            filterOptions(data),
            filter.formatOptionLabel
        );
    }

    const handleChange = event => {
        onChange(event.target.value);
    };
    return (
        <FormControl className={classes.formControl}>
            <InputLabel>Select</InputLabel>
            <Select
                className={classes.selectField}
                onChange={handleChange}
                value={value}
                MenuProps={{
                    PopoverClasses: {
                        paper: classes.menuPopover,
                    },
                }}
            >
                {filterOptions.map(item => (
                    <MenuItem key={item.value} value={item.value}>
                        {item.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export { SelectFilter };
